import React from "react";
import { Dialog, DialogContent, IconButton, styled } from "@mui/material";
import { ControlledTextField, PhoneTextField } from "../../components/inputs";
import { CloseSharp } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { Form, Title, Button } from "../../components";

const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    width: 100%;
  }
`;
const CloseIconButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`;

const EnviarViaWhatsAppDialogDialog = ({
  handleSubmit,
  submitting,
  handleClose,
  formProps,
  open,
}) => {
  return (
    <StyledDialog
      onClose={() => {}}
      disableEscapeKeyDown
      maxWidth="sm"
      open={open}
    >
      <DialogContent>
        {!submitting && (
          <CloseIconButton onClick={handleClose}>
            <CloseSharp />
          </CloseIconButton>
        )}
        <Title as={"h2"} _margin_={"0 0 1rem 0"}>
          Confirme o celular do cliente
        </Title>
        <Form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={12}>
              <ControlledTextField
                formProps={formProps}
                name={"telefone"}
                label={"Celular do cliente"}
                InputProps={{
                  inputComponent: PhoneTextField,
                }}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12} md={8}>
              <Button loading={submitting} type={"submit"} fullWidth>
                ENVIAR MENSAGEM
              </Button>
            </Grid>
          </Grid>
        </Form>
      </DialogContent>
    </StyledDialog>
  );
};

export default EnviarViaWhatsAppDialogDialog;
